import {IStructure} from './structure.model';


export interface ICampStructure  {
  id?: number;
  structure?: IStructure;
  organisatrice?: boolean;
  participante?: boolean;
}

export class CampStructure implements ICampStructure {
  constructor(
    public id?: number,
    public structure?: IStructure,
    public organisatrice?: boolean,
    public participante?: boolean
  ) {}
}
